import Widget, { type WidgetComponentProps } from 'app/common/components/widgets/widget';
import { getWidgetId } from '../../util/widget.js';

export function ObjectFieldWrapper({ children, ...props }: WidgetComponentProps) {
  const { formName, path } = props;

  let testId: string | undefined;

  if (formName && path) {
    testId = `${getWidgetId({ formName, path })}__objectFieldWrapper`;
  }

  return (
    <Widget testId={testId} {...props}>
      <div className="flex flex-col gap-6 p-4 border border-solid border-gray-300 rounded">{children}</div>
    </Widget>
  );
}
